import axios from 'axios';
import { Code } from 'constants/codes';

// Create an Axios instance for login
const apiLogin = axios.create({
    baseURL: Code.Path.SERVER, // current server
    headers: {
      'Content-Type': 'application/json',
    },
    timeout: 10000, // requests timeout in 10 seconds
  });
  
  // Request interceptor
  apiLogin.interceptors.request.use(
    async (config) => {
      try {
        
        //send the request
        return config;
      } 
      catch (error) {
        console.error('Error in request interceptor:', error);
        return Promise.reject(error);
      }
    },
    (error) => {
      // Handle request errors
      return Promise.reject(error);
    }
  );
  
  // Response interceptor
  apiLogin.interceptors.response.use(
    (response) => response,
    (error) => {
  
      // Log or handle specific HTTP error responses
      if (error.response?.status === 401) {
        console.error('Unauthorized! Redirecting to login...');
        // Redirect to the login page
      }
  
      return Promise.reject(error);
    }
  );
  
  export default apiLogin;